import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Home as HomeIcon } from "lucide-react";
import Seo from "@/components/Seo";
import Breadcrumbs from "@/components/Breadcrumbs";
import { SERVICES } from "@/data/services";

export default function Services() {
  return (
    <>
      <Seo
        title="Eye Care Services in Noida — Cataract, Oculoplasty, Glaucoma"
        description="Comprehensive eye care services at Nehchal Eye Centre, Sector 32 Noida. Cataract surgery, oculoplasty, glaucoma, pediatric eye care, refractive surgery & more."
        path="/services"
      />
      <Breadcrumbs items={[{ name: "Services", path: "/services" }]} />

      <section className="container-wide pt-10 pb-20">
        <div className="max-w-2xl mb-14">
          <div className="text-xs uppercase tracking-widest text-accent mb-3">What We Offer</div>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-foreground leading-[1.05]">
            Our Services in Noida.
          </h1>
          <p className="mt-6 text-foreground/70 leading-7">
            Comprehensive eye care with state-of-the-art technology — delivered by Dr. Gurkiran Kaur and team at Sector 32, Wave City Centre.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <Link
            to="/eye-checkup-at-home"
            className="group rounded-xl border border-primary/40 bg-primary/5 hover:shadow-sm transition-all p-6 flex flex-col"
            data-testid="service-card-home-visit"
          >
            <div className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-primary mb-2"><HomeIcon className="h-3.5 w-3.5" /> New · At your home</div>
            <div className="font-serif text-xl text-foreground group-hover:text-primary transition-colors">Home Eye Check-up</div>
            <p className="mt-2 text-sm text-foreground/70 leading-6 flex-1">Portable slit lamp, undilated fundus photo, vision &amp; refraction and a virtual consult with Dr. Kaur — across Noida &amp; Greater Noida.</p>
            <div className="mt-4 inline-flex items-center gap-1 text-xs text-primary">
              Learn more <ArrowRight className="h-3 w-3" />
            </div>
          </Link>
          {SERVICES.map((s) => (
            <Link
              key={s.slug}
              to={`/services/${s.slug}`}
              className="group rounded-xl border border-border bg-card hover:border-primary/40 hover:shadow-sm transition-all p-6 flex flex-col"
              data-testid={`service-card-${s.slug}`}
            >
              <div className="font-serif text-xl text-foreground group-hover:text-primary transition-colors">
                {s.name}
              </div>
              <p className="mt-2 text-sm text-foreground/70 leading-6 flex-1">{s.short}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs text-primary">
                Learn more <ArrowRight className="h-3 w-3" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
